import { User } from '../../../entity/User'
import * as yup from 'yup'
import { passwordInput } from '../../inputs/controls'
import { controllerErrors } from '../../../utils/validationErrors/controllerErrors'

type AuthAccount = {
    login: string
    oldPassword: string
    newPassword: string
    confirmPassword: string
}

export const getAuthAccountFields = (user: User): AuthAccount => ({
    login: user.login,
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
})

export const getAuthAccountValidationSchema = () => ({
    login: yup.string().required(),
    oldPassword: yup.string().min(5).required(),
    newPassword: yup.string().min(5).required(),
    confirmPassword: yup.string().min(5).required(),
})

export const getPasswordInputControlDescriptors = (state: any) => [
    passwordInput({
        name: 'oldPassword',
        label: 'user.account.currentPassword',
        isColumn: true,
        className: 'mb-2',
        isRequired: true,
        inputType: 'password',
        errMsg: controllerErrors.adminControllerOldPassword(state),
    }),
    passwordInput({
        name: 'newPassword',
        label: 'user.account.newPassword',
        isColumn: true,
        className: 'mb-2',
        isRequired: true,
        inputType: 'password',
        errMsg: controllerErrors.adminControllerNewPassword(state),
    }),
    passwordInput({
        name: 'confirmPassword',
        label: 'user.account.confirmPassword',
        isColumn: true,
        className: 'mb-2',
        isRequired: true,
        inputType: 'password',
        errMsg: controllerErrors.adminControllerRepeatPassword(state),
    }),
]
